// src/pwa/installManager.js
export class InstallManager {
  constructor() {
    this._deferred = null;
    this._listeners = [];
  }

  init() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this._deferred = e;
      this._listeners.forEach(fn => fn(true));
    });

    window.addEventListener('appinstalled', () => {
      this._deferred = null;
      this._listeners.forEach(fn => fn(false));
    });
  }

  async prompt() {
    if (!this._deferred) return;
    this._deferred.prompt();
    const { outcome } = await this._deferred.userChoice;
    if (outcome === 'accepted') {
      this._deferred = null;
      this._listeners.forEach(fn => fn(false));
    }
  }

  // fn(isAvailable: boolean) — called when install availability changes
  onAvailabilityChange(fn) {
    this._listeners.push(fn);
  }
}
